import { fetchUtils } from 'react-admin';

const httpClient = (url: string, options: fetchUtils.Options = {}) => {
  const baseUrl = import.meta.env.VITE_SIMPLE_REST_URL || 'http://localhost:3000';
  const accessToken = localStorage.getItem('accessToken');
  const tenantCode = localStorage.getItem('currentTenant')
    ? JSON.parse(localStorage.getItem('currentTenant')!).code
    : 'default';

  options.user = {
    authenticated: true,
    token: 'Bearer ' + accessToken,
  };

  options.headers = new Headers({
    'x-tenant-code': tenantCode,
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + accessToken,
  });

  const response = fetchUtils.fetchJson(`${baseUrl}/${url}`, options);
  return response;
};

export const markChannelAsRead = (params: any) => {
  return httpClient(`chat-channels/${params.channelId}/last-read`, {
    method: 'PUT',
    body: JSON.stringify({
      lastReadAt: params.lastReadAt ?? new Date().toISOString(),
    }),
  });
};

export const createChatChannel = (params: any) => {
  return httpClient(`chat-channels`, {
    method: 'POST',
    body: JSON.stringify(params),
  }).then(({ json }) => ({ data: json }));
};

export const sendChatMessage = (params: any) => {
  return httpClient(`chat-messages`, {
    method: 'POST',
    body: JSON.stringify(params),
  })
    .then(({ json }) => ({ data: json }))
    .catch(e => {
      error: e.message;
    });
};

export const getTotalUnreadMessages = () => {
  return httpClient(`chat-channels/totalUserUnreadMessageCounts`, {
    method: 'GET',
  }).then(({ json }) => ({ data: json }));
};

export const registerDeviceForPushNotifications = (params: any) => {
  return httpClient(`notifications/register-device`, {
    method: 'POST',
    body: JSON.stringify({
      type: 'Web',
      deviceToken: params.deviceToken,
    }),
  });
};

export const deleteRegisteredDeviceFromPushNotifications = (params: any) => {
  return httpClient(`notifications/register-device/${params.deviceToken}`, {
    method: 'DELETE',
  });
};
